import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-insight',
  templateUrl: './insight.component.html',
  styleUrls: ['./insight.component.scss']
})
export class InsightComponent implements OnInit {

  @Input() tabData;

  constructor() { }

  ngOnInit(): void {
  }

}
